import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  updateBuilding: boolean;
}

export type Args = {
  buildingId: string;
  name?: string;
  token?: string;
  groupId?: string;
  isDeleted?: boolean;
};

export const updateBuilding = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { buildingId, name, token, groupId, isDeleted } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      buildingId,
      name,
      token,
      groupId,
      isDeleted
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
